// 舌象分析模块 - 合并「舌色」与「青紫」，并将 jiangjie 洗成便于渲染的数组
// tizhi_content 已在 pipeline.parseBase 中完成 JSON.parse
const TONGUE_JIANGJIE_SKIP_NAMES = ['舌形', '暗短', '舌根'];

export default function transform(data) {

    if (!data || !data.tizhi_content) return;
    const tc = data.tizhi_content;
    const tongue = tc.tongue;
    if (!Array.isArray(tongue)) return;

    const jiangjieRaw = tc.jiangjie && typeof tc.jiangjie === 'object' && !Array.isArray(tc.jiangjie)
        ? tc.jiangjie
        : null;

    const seColor = tongue.find((t) => t.name === '舌色');
    const qingzi = tongue.find((t) => t.name === '青紫');
    if (seColor && qingzi) {
        if (qingzi.data === '青紫' && seColor.data !== '绛红') {
            seColor.data = seColor.data + '(含青紫)';
        }
        tc.tongue = tongue.filter((t) => t.name !== '青紫');
    }

    const list = [];
    for (const t of tc.tongue) {
        if (!t || !t.name) continue;
        if (TONGUE_JIANGJIE_SKIP_NAMES.includes(t.name)) continue;
        const d = t.data;
        if (d == null) continue;
        const name = t.name;
        const node = jiangjieRaw && jiangjieRaw[name];
        let Jiangjie;
        let Jiangkang;
        if (node && typeof node === 'object' && !Array.isArray(node)) {
            Jiangjie = node.Jiangjie;
            Jiangkang = node.Jiangkang;
        } else if (typeof node === 'string') {
            Jiangjie = node;
        }
        list.push({
            name,
            data: t.data,
            Jiangjie,
            Jiangkang
        });
    }

    tc.jiangjie = list.length > 0 ? list : null;
}
